import React from 'react'
import PropTypes from 'prop-types'
import FieldGroupComponent from '../../../components/core/FieldGroupComponent/FieldGroupComponent'

import 'react-select/dist/react-select.css'

import { PLATFORMS, COMPANY_SIZES, INDUSTRIES, VERTICALS, COUNTRIES } from '../../../constants/companyConstants'

class CompanyFormFieldsLayout extends React.Component {
    render() {
        const { otherFields } = this.props;

        return <div>
            <FieldGroupComponent
                label="Company Name"
                name="name"
                type="text"
                formProps={{
                    maxLength: 100,
                }}
            />
            <FieldGroupComponent
                label="Address"
                name="address"
                type="text"
                formProps={{
                    maxLength: 100,
                }}
            />
            <FieldGroupComponent
                label="City"
                name="city"
                type="text"
                formProps={{
                    maxLength: 100,
                }}
            />
            <FieldGroupComponent
                label="State"
                name="state"
                type="text"
                formProps={{
                    maxLength: 100,
                }}
            />
            <FieldGroupComponent
                label="Country"
                name="country"
                type="select"
                formProps={{
                    id: 'country',
                    options: COUNTRIES,
                }}
            />
            <FieldGroupComponent
                label="Postal / ZIP Code"
                name="postalCode"
                type="text"
                formProps={{
                    maxLength: 20,
                }}
            />
            <FieldGroupComponent
                label="Phone Number"
                name="phoneNumber"
                type="text"
                required={false}
                formProps={{
                    maxLength: 20,
                }}
            />
            <FieldGroupComponent
                label="Enrollment Type"
                name="platform"
                placeholder={'Select Options'}
                type="select"
                formProps={{
                    id: 'platform',
                    options: PLATFORMS,
                    multiWithCheckbox: true,
                }}
            />
            <FieldGroupComponent
                label="Number of Employees"
                name="companySize"
                type="select"
                formProps={{
                    id: 'companySize',
                    options: COMPANY_SIZES,
                }}
            />
            <FieldGroupComponent
                label="Industry"
                name="industry"
                type="select"
                formProps={{
                    id: 'industry',
                    options: INDUSTRIES,
                }}
            />
            {otherFields.industry && <FieldGroupComponent
                name="otherIndustry"
                type="text"
                formProps={{
                    maxLength: 100,
                }}
            />}
            {otherFields.isFitnessIndustry && <FieldGroupComponent
                label="Fitness Vertical"
                name="vertical"
                type="select"
                formProps={{
                    id: 'vertical',
                    options: VERTICALS,
                }}
            />}
            {otherFields.vertical && otherFields.isFitnessIndustry && <FieldGroupComponent
                name="otherVertical"
                type="text"
                formProps={{
                    maxLength: 100,
                }}
            />}
        </div>
    }
}

CompanyFormFieldsLayout.propTypes = {
    otherFields: PropTypes.object.isRequired,
}

export default CompanyFormFieldsLayout



// WEBPACK FOOTER //
// ./src/layouts/Company/CompanyForm/CompanyFormFieldsLayout.js